import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  Card,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import { getCurrentYear } from "../../../../common/shared";
import InsuranceCard from "./InsuranceCard";
import addIcon from "../../../../assets/add.png";
import bucksIcon from "../../../../assets/plancreation/bucks.png";

const columns = [
  { id: "owner", label: "Owner", minWidth: 170 },
  { id: "policyType", label: "Policy Type", minWidth: 170 },
  {
    id: "deathBenefitValue",
    label: "Death Benefit Value",
    minWidth: 170,
  },
  {
    id: "cashValue",
    label: "Cash Value",
    minWidth: 170,
  },
];

const InsuranceTab = ({
  updateInsurances,
  data,
  changed,
  deleteItem,
  clearInsurances,
}) => {
  const [insurances, setInsurances] = useState(data ? data : []);
  const [hasInsurance, setHasInsurance] = useState(data.length > 0);

  useEffect(() => {
    updateInsurances(insurances);
  }, [insurances]);

  const addInsurance = () => {
    const currentIndex = Math.max(...insurances.map((e) => e.editIndex));

    const newInsurance = {
      id: null,
      editIndex: currentIndex >= 0 ? currentIndex + 1 : 0,
      name: `insurnace-${currentIndex}`,
      clientId: null,
      appliesTo: null,
      scopeType: "PLAN",
      policyType: null,
      endDateValid: true,
      deathBenefit: 0.0,
      premium: 0.0,
      cashValue: 0.0,
      policyEndDate: getCurrentYear(),
      isEdited: false,
      isCopied: false,
      inEdit: true,
      isNew: true,
    };

    setInsurances((v) => [...v, newInsurance]);
    changed();
  };

  const removeInsurance = (insurance) => {
    deleteItem(insurance).then(() => {
      setInsurances((v) =>
        v.filter((ins) => ins.editIndex !== insurance.editIndex)
      );
      changed();
    });
  };

  const onUpdate = (editIndex) => (field) => (value) => {
    setInsurances((v) =>
      v.map((ins) => {
        if (ins.editIndex !== editIndex) return ins;
        return {
          ...ins,
          [field]: value,
        };
      })
    );
    changed();
  };

  const handleHasInsuranceChange = (e) => {
    const isHasInsuranceChecked = e.target.checked;

    if (!isHasInsuranceChecked) {
      setHasInsurance(isHasInsuranceChecked);
      clearInsurances();
      setInsurances([]);
      return;
    }

    setHasInsurance(e.target.checked);
    setInsurances(
      e.target.checked
        ? [
            {
              id: null,
              editIndex: 0,
              name: "insurance - 0",
              clientId: null,
              appliesTo: null,
              scopeType: "PLAN",
              policyType: null,
              endDateValid: true,
              deathBenefit: 0,
              premium: 0.0,
              cashValue: 0.0,
              policyEndDate: getCurrentYear(),
              isEdited: false,
              isCopied: false,
              inEdit: true,
              isNew: true,
            },
          ]
        : []
    );
    changed();
  };

  return (
    <Grid
      container
      id="insurance-tab"
      className="tab-container"
      direction="row"
      md={9}
      spacing={6}
    >
      <Grid xs={12} item>
        <Typography component="h5">Life Insurance Policy</Typography>
      </Grid>
      <Grid xs={12} item>
        <Card className="card">
          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid
              item
              container
              direction="row"
              xs
              spacing="2"
              alignItems="center"
              className="flex-nowrap"
            >
              <img className="img" src={bucksIcon} alt="bucks-img" />
              <Box>
                <Typography className="title">
                  Does your client have Insurance?
                </Typography>
                <Typography className="description" variant="caption">
                  Life Insurance is not directly calculated into the plan. Life
                  Insurance coverage is used to calculate potential shortfalls
                  based on future expenses.
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Switch
                checked={hasInsurance}
                onChange={handleHasInsuranceChange}
                color="primary"
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Collapse
          in={hasInsurance}
          timeout="auto"
          unmountOnExit
          className={"insurance-collapse-container"}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {insurances.map((item, index) => (
                    <InsuranceCard
                      canDelete={index > 0}
                      onDelete={removeInsurance}
                      onUpdate={onUpdate(item.editIndex)}
                      insurance={item}
                    />
                  ))}
                </TableBody>
              </Table>
            </Grid>
            <Grid
              item
              container
              xs={3}
              direction="row"
              spacing="2"
              className="add-insurance"
              onClick={addInsurance}
            >
              <Grid item>
                <img className="add-new" src={addIcon} alt="add-new-icon" />
              </Grid>
              <Grid item>
                <Typography component="div">Add Insurance</Typography>
              </Grid>
            </Grid>
            <Grid item xs={9} />
          </Grid>
        </Collapse>
      </Grid>
    </Grid>
  );
};

export default InsuranceTab;
